import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GetChannelMembershipPreferencesResponseFilterSensitiveLog, } from "../models/models_0";
import { de_GetChannelMembershipPreferencesCommand, se_GetChannelMembershipPreferencesCommand, } from "../protocols/Aws_restJson1";
export { $Command };
export class GetChannelMembershipPreferencesCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "GetChannelMembershipPreferences", {})
    .n("ChimeSDKMessagingClient", "GetChannelMembershipPreferencesCommand")
    .f(void 0, GetChannelMembershipPreferencesResponseFilterSensitiveLog)
    .ser(se_GetChannelMembershipPreferencesCommand)
    .de(de_GetChannelMembershipPreferencesCommand)
    .build() {
}
